

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
@Component({
  components: { SafetyAndEnvironmentDialog },
})
export default class ViewInnerPages extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  @Prop(String) rowTitle!: any; // 传递给编辑页面-数据对象

  private titleContent: any = '';
  private newList: any = [];
  // 表单数据
  formData: any = {};

  formRules: any = {};

  // 职务
  assessScoreOptions: any = [
    {
      value: 1,
      label: '加分',
    },
    {
      value: 0,
      label: '扣分',
    },
  ];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.titleContent = this.rowTitle; // 标题
    // // 获取分页数据
    this.getPageData();
  }

  changeProject(data: any) {
    if (this.formData.assessType) {
      const safetyDialog = 'safetyDialog';
      const safetyDialogComponent = this.$refs[safetyDialog];
      (safetyDialogComponent as any).showDialog(this.formData.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    } else {
      this.$message.warning('请先选择考核类型！');
    }
  }

  getAssessStandConfig(data: any) {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer.getAssessStandConfigAll({ assessType: data }).then((res: any) => {
      this.newList = res.data;
    });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getViewRecordsData(this.row.id)
      .then((res: any) => {
        // this.getAssessStandConfig(res.data.assessType);
        res.data.adjustPointsFlag = res.data.adjustPointsFlag === true ? 1 : 0;
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });

    this.$forceUpdate();
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    if (data) {
      this.formData.adjustAssessProject = data.assessProject;
      this.formData.adjustAssessContent = data.assessContent;
      this.formData.adjustAssessStand = data.assessStand;
    } else {
      this.formData.adjustAssessProject = '';
      this.formData.adjustAssessContent = '';
      this.formData.adjustAssessStand = '';
    }

    this.$forceUpdate();
  }

  getNameById(id: any) {
    let a: any = '';
    this.newList.forEach((re: any) => {
      if (re.id === id) {
        return (a = re.assessProject);
      }
      return a;
    });
    return a;

    //   const obj: any = this.assessStandConfigOptions.find((obj: any) => {
    //     return obj.id === id;
    //   });
    // console.log(obj)
    //   return obj.assessProject;
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  /**
   * @desc 点击取消按钮
   */
  save() {
    safetyAndEnvironmentAssessmentServer
      .editInnerData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功');
          this.close();
        } else {
          this.$message.error(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('编辑失败');
      });
  }
}
